<template>
  <v-app>
    <Header :isPublic="true" />
    <v-main>
      <div id="body">

      <v-container fluid class="body_content">
        <v-alert text type="info">
          <small class="text-info">
            Informação atualizada até {{ returnDateNow() }}
          </small>
        </v-alert>

        <h2>Pesquisa de Prejulgado</h2>

        <v-row>
          <v-col cols="12" md="5">
            <v-text-field
                v-on:keyup.enter="buscar()"
                label="Pesquisar por Excerto"
                v-model="filtro.livrePesquisa"
            />
          </v-col>
          <v-col cols="12" md="1">
            <v-text-field
                v-on:keyup.enter="buscar()"
                type="number"
                label="Processo"
                v-model="filtro.numeroProcesso"
            />
          </v-col>
          <v-col cols="12" md="1">
            <v-text-field
                v-on:keyup.enter="buscar()"
                type="number"
                label="Ano"
                v-model="filtro.ano"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
                v-on:keyup.enter="buscar()"
                label="Gestor Responsável"
                v-model="filtro.gestor"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
                v-on:keyup.enter="buscar()"
                label="Relator"
                v-model="filtro.relator"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="5">
            <v-select
                solo
                dense
                v-model="temaSelected"
                :items="listaTema"
                item-text="nome"
                item-value="temaId"
                label="Tema"
                return-object
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
                solo
                dense
                v-model="filtro.subtema"
                :items="temaSelected.subTemas"
                item-text="nome"
                item-value="subtemaId"
                label="Subtema"
            ></v-select>
          </v-col>

          <v-col cols="12" md="2" style="margin-top: 0.8%">
            <v-btn
                color="primary"
                small
                depressed
                :loading="loadingBusca"
                :disabled="loadingBusca"
                @click="buscar()"
            >
              <v-icon small>fa-search</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-alert v-if="erroServico" type="error" outlined dense class="mt-4">
          Não foi possível consultar os prejulgados no momento. Tente novamente em instantes.
        </v-alert>

        <v-row justify="center">
          <v-col cols="12" md="12">
            <template>
              <v-data-table
                  @click:row="abrirDialog"
                  :headers="headers"
                  :items="lista"
                  :items-per-page="10"
                  :loading="loadingBusca"
                  class="elevation-1 mytable"
                  no-results-text="A busca não trouxe resultados."
                  :no-data-text="erroServico ? 'Não foi possível carregar os dados.' : 'A busca não trouxe resultados.'"
              >
                <template v-slot:loading>
                  <LoadingSpinner text="Carregando prejulgados... aguarde." />
                </template>

                <!-- RETIRADO A PEDIDO DE RENAN https://app.clickup.com/t/23ze4xk
                  <template v-slot:item.dataInclusaoFormatada="{ item }">
                  <span>{{
                    item.dataInclusao? $moment(item.dataInclusao).format("DD/MM/YYYY") : "Não Informado"
                  }}</span>
                </template> -->
              </v-data-table>
            </template>

            <v-dialog v-model="dialog" max-width="800px">
              <v-card>
                <v-card-title class="grey lighten-2">
                  Referente ao Processo: {{ excerto.cdProcesso || "" }}/{{
                    excerto.cdAno || ""
                  }}
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            type="number"
                            label="Prejulgado"
                            v-model="excerto.excertoId"
                        ></v-text-field>
                      </v-col>
                      <!--  <v-col cols="12" md="3">
                         <v-text-field
                         v-if="excerto.dataInclusao"
                         disabled
                         class="font-weight-black"
                         label="Inclusão"
                         type="date"
                         mask="dd/MM/yyyy"
                         v-model="excerto.dataInclusao"
                       ></v-text-field>
                       <v-text-field
                         v-else
                         disabled
                         class="font-weight-black"
                         label="Inclusão"
                         value="Não Informado"
                       ></v-text-field>
                       </v-col> -->
                      <v-col cols="12" md="2">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            type="number"
                            label="Exercício Financeiro"
                            v-model="excerto.processo.exercicio"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Natureza"
                            v-model="excerto.processo.natureza"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <!-- <v-col cols="12" md="1">
                        <v-text-field
                          disabled
                          type="number"
                          label="Processo"
                          v-model="excerto.cdProcesso"
                          class="font-weight-black"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="1">
                        <v-text-field
                          disabled
                          type="number"
                          label="Ano"
                          v-model="excerto.cdAno"
                          class="font-weight-black"
                        ></v-text-field>
                      </v-col> -->

                      <v-col cols="12" md="6">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Tema"
                            v-model="excerto.subtema.temaDTO.nome"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="SubTema"
                            v-model="excerto.subtema.nome"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="12" md="6">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Responsável"
                            v-model="excerto.processo.responsavel"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Relator"
                            v-model="excerto.processo.relator"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="12" md="12">
                        <v-text-field
                            disabled
                            class="font-weight-black"
                            label="Origem"
                            v-model="excerto.processo.unidade"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="12" md="12">
                        <v-textarea
                            disabled
                            rows="2"
                            outlined
                            auto-grow
                            counter
                            name="texto"
                            label="Excerto"
                            v-model="excerto.texto"
                            class="font-weight-black"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" md="12">
                        <v-textarea
                            disabled
                            rows="2"
                            outlined
                            auto-grow
                            counter
                            name="observacao"
                            label="Observação"
                            v-model="excerto.observacao"
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <template>
                      <v-data-table
                          @click:row="abrirDecisao"
                          :headers="headersDelib"
                          :items="deliberacoes"
                          hide-default-footer
                          class="elevation-1 mytable"
                          no-results-text="Não existem deliberações."
                          no-data-text="Não existem deliberações."
                      >
                        <template v-slot:item.dataSessaoFormatada="{ item }">
                        <span>
                          {{ new Date($moment(item.dataSessao).format()).toLocaleDateString() }}
                        </span>
                        </template>
                        <template v-slot:item.dataCirculacaoFormatada="{ item }">
                        <span>
                          {{ new Date($moment(item.dataCirculacao).format()).toLocaleDateString() }}
                        </span>
                        </template>
                      </v-data-table>
                    </template>
                  </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog = false"
                  >Fechar
                  </v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/template/Header.vue";
import LoadingSpinner from "@/components/template/LoadingSpinner.vue";
import excertoService from "@/service/ExcertoService";
import Excerto from "@/model/excerto"

export default {
  components: {
    Header,
    LoadingSpinner
  },
  data() {
    return {
      dialog: false,
      loadingBusca: false,
      erroServico: false,
      temaSelected: {},
      listaTema: [],
      lista: [],
      excerto: Excerto(),
      deliberacoes: [],

      filtro: {
        livrePesquisa: null,
        subtema: null,
        numeroProcesso: null,
        ano: null,
        exercicioFinanceiro: null,
        gestor: null,
        relator: null,
      },

      headers: [
        {text: "Prejulgado.", value: "excertoId", sortable: false},
        {text: "Nº Processo", value: "cdProcesso", sortable: false},
        {text: "Ano Processo", value: "cdAno", sortable: false},
        {text: "Natureza", value: "processo.natureza", sortable: false},
        {text: "Origem", value: "processo.unidade", sortable: false},
        // { text: "Inclusão", value: "dataInclusaoFormatada", sortable: false },
      ],
      headersDelib: [
        {text: "Data da Sessão", value: "dataSessaoFormatada"},
        {text: "Publicação", value: "dataCirculacaoFormatada"},
        {text: "Tipo da Decisão", value: "tipoDeliberacao"},
        /* { text: "Abrir Decisão", value: "actions", align:"center" }, */
      ]
    };
  },
  methods: {
    returnDateNow() {
      return this.$moment().format("DD/MM/YYYY");
    },

    abrirDialog(item) {
      Object.assign(this.excerto, item);
      excertoService
          .buscarDeliberacoes(this.excerto.processo.processoId)
          .then(result => this.deliberacoes = result);
      this.dialog = true;
    },
    abrirDecisao(item) {
      if (item.textoDecisao != null && item.textoDecisao != "") {
        let rota = this.$router.resolve(
            "/decisao/" +
            item.deliberacaoId
        );
        window.open(rota.href, "_blank");
      } else alert("Este documento não possui visualização HTML!");
    },
    buscar() {
      if (this.loadingBusca) return; //evita disparar buscas empilhadas pelo enter
      this.loadingBusca = true;
      this.erroServico = false;
      this.lista = []; //limpa antes: senão a tabela mostra os resultados antigos + a barra em vez do spinner
      excertoService
          .buscarExcertoFiltro(this.filtro)
          .then((result) => (this.lista = result || []))
          .catch(() => {
            // falha real (rede/API fora do ar): aviso de indisponibilidade
            this.lista = [];
            this.erroServico = true;
          })
          .finally(() => (this.loadingBusca = false));
    },
    findAllTemas() {
      excertoService.findAllTemas().then((result) => (this.listaTema = result));
    }
  },
  created() {
    this.findAllTemas();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style scoped>
.body_content {
  margin: auto;
  padding: 2rem 5rem;
}

.text-info {
  color: #000000;
}
</style>